/**
 * DateTimePickerFooter
 *
 * Confirm and Cancel buttons for the combined date/time picker modal.
 */

import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import { BorderRadius, Spacing } from '@/constants/spacing';
import { getBodyFont } from '@/constants/typography';
import type { Colors } from '@/constants/theme';

type DateTimePickerFooterProps = {
  onConfirm: () => void;
  onCancel: () => void;
  accentColor: string;
  palette: typeof Colors.light;
};

export function DateTimePickerFooter({
  onConfirm,
  onCancel,
  accentColor,
  palette,
}: DateTimePickerFooterProps) {
  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={onCancel} style={styles.cancelButton} activeOpacity={0.7}>
        <Text style={[styles.cancelText, { color: palette.textMuted, fontFamily: getBodyFont() }]}>
          Cancel
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        onPress={onConfirm}
        style={[styles.confirmButton, { backgroundColor: accentColor }]}
        activeOpacity={0.8}
      >
        <Text style={[styles.confirmText, { fontFamily: getBodyFont() }]}>
          Confirm
        </Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.md,
    gap: Spacing.md,
  },
  cancelButton: {
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.sm,
  },
  cancelText: {
    fontSize: 14,
    fontWeight: '500',
  },
  confirmButton: {
    paddingHorizontal: Spacing.xl,
    paddingVertical: Spacing.sm,
    borderRadius: BorderRadius.sm,
  },
  confirmText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
});
